import { Collection } from 'caldera-immutable-model';
import SubTask from './SubTask';

type Id = number | string;

export default class SubTaskCollection extends Collection {
  static Model = SubTask;

  filterByParentTask(parentTaskId: Id): SubTaskCollection {
    return this.filter(subTask => subTask.parentTask === parentTaskId);
  }
}



// WEBPACK FOOTER //
// ./src/models/SubTaskCollection.js